__webpack_require__.p = "/tech/";